import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom'; // for routing
import { PersistGate } from 'redux-persist/integration/react'; // for persist data in redux store

import '@locales/i18n'; // for langugage translations
import { persistor, store } from '@store/store';

import App from './App';
import './styles/main.scss';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</PersistGate>
		</Provider>
	</StrictMode>,
);
